import script from "./DeviceTask.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceTask.vue?vue&type=script&setup=true&lang=js"

import "./DeviceTask.vue?vue&type=style&index=0&id=2e05c94b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e05c94b"]])

export default __exports__